<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <QuestionFish :data="data" @jump="jump"></QuestionFish>
    </div>
</template>

<script>
    //script
    import Tools from "../../../scripts/tools";
    import {gsap} from "gsap";
    //Global
    import Global from "../../../scripts/Global";
    import QuestionFish from "../../cmp/questionFish";

    export default {
        data() {
            return {
                data: {
                    headTipImg: "苏尚卿讲解",
                    headTipTxt: "你瞧，这池中的锦鲤， 据说能给人带来好运呢？你也捞捞看？",
                    // headTipPathTxt: '前往浮壁亭 >>',
                    headTipPath: "/rodemap/ssq/03",

                    qText: "点击图中任意锦鲤，把它捞出来吧",
                    qImg: "万春亭配图",
                    errText: "已图片选择的方式，完成拼图小游戏！拼出万春亭藻并画"
                }
            };
        },
        components: {
            QuestionFish
        },
        created() {
            Global.startPlay("ssq", "scene13");
        },
        computed: {},
        methods: {
            jump(event) {
                Global.yubi.ssq.b4 = true;
                let headTipPath = "";
                if (Object.keys(Global.yubi.ssq).length >= 4) {
                    headTipPath = "/bonus?giftRoad=ssq";
                } else {
                    headTipPath = "/result";
                }
                Global.curr = {
                    bg: "浮碧亭",
                    ybtxt: "",
                    ...this.data,
                    headTipImg: "苏尚卿讲解",
                    headTipTxt: "好厉害呢，今年你一定可以获得好运加成呢！这个当做是你陪了我一天的谢礼，收好啦。",
                    headTipPath,
                    headTipPathTxt: "前往下一站 >>",
                    ybResultImg: "苏",
                    ybResultHTML: `<p>谢谢你的陪伴！</p>
        <p>今天真的学到很多呢！很可惜，我们没收集到4枚玉璧，没办法参与抽奖！</p>
        <p>
          你可以继续挑战本关，也可以重新选择我的伙伴们，让他们带你继续参观哦！
        </p>`,
                    ybCallback: () => {
                        if (Object.keys(Global.yubi.ssq).length >= 4) {
                            setTimeout(() => {
                                window.Global.startPlay("ssq", "scene16");
                            }, 500);
                        } else {
                            setTimeout(() => {
                                window.Global.startPlay("ssq", "scene15");
                            }, 500);
                        }
                    },
                    textCfg: {
                        "text-align": "center"
                    }
                };

                this.$router.replace("/yu");
                Global.startPlay("ssq", "scene14");
            }
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/浮碧亭.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
